import { Component } from "@angular/core";
import { RouterOutlet } from "@angular/router";
import { LoaderComponent } from "@shared/components/loader/loader.component";
import { ToastMessageComponent } from "@shared/components/toast-message/toast-message.component";

@Component({
  selector: "app-root",
  imports: [RouterOutlet, LoaderComponent, ToastMessageComponent],
  templateUrl: "./app.component.html",
  styleUrl: "./app.component.scss",
  standalone: true,
})

export class AppComponent {}